export default (): OnOffButtonComponent => {
    return {
        isOn: false,
        onOnOffButtonClick() {
            this.isOn = !this.isOn;
            console.log(this.isOn)
        }
    };
};

import {AlpineComponent} from "alpinejs"

type OnOffButtonComponent = AlpineComponent<{
    isOn: boolean,
    onOnOffButtonClick: Function
}>
